import { utils } from '@sfaas/util';
import * as types from './mutation-types';

export default {
	stnCds_: state => {
		const { stnCds } = state.selectOptions;
		return [{ label: 'ALL', value: 'ALL' }, ...stnCds];
	},

	plantCd_: state => {
		const { plantCd } = state.searchParams;
		return plantCd;
	},

	shopCd_: state => {
		const { shopCd } = state.searchParams;
		return shopCd;
	},
	stnCd_: state => {
		const { stnCd } = state.searchParams;
		return stnCd;
	},
	stnName_: state => {
		const { stnName } = state.searchParams;
		return stnName;
	},

	show_: state => {
		const { show } = state.popupParams;
		return show;
	}
};
